export namespace Enums {
  export enum UserPropertyTypes {
    SuperReferer = 1,
    TelegramId = 2,
    TwitterId = 3,
  }
}
